import { render, staticRenderFns } from "./SkeletonHeroBanner.vue?vue&type=template&id=3b265d12"
import script from "./SkeletonHeroBanner.vue?vue&type=script&lang=js"
export * from "./SkeletonHeroBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports